
import CryptoJS from 'crypto-js';
const secretKey = 'sinoeve';

function urlQueryParams(){
  if(window.location.hash&&window.location.hash.split('?')[1]) {
    let queryArr = window.location.hash.split('?')[1].split('&');
    let queryParams = {};
    queryArr.map(item=>{
      if(!/=/.test(item)) return;
      queryParams[item.split('=')[0]] = item.split('=')[1]
    });
    return queryParams;
  }else {
    return null;
  }
}
export function getToken(){
  // if(process.env.NODE_ENV === "development") return "390eb887090e83756073b382ea5f5cba";
  let queryParams = urlQueryParams();
  if(!queryParams) return "";
  if(queryParams.AES) {
    let decode = decodeURIComponent(queryParams.AES);
    let str = decryptData(decode);
    let query = JSON.parse(str);
    return query.accessToken;
  }else {
    let token = queryParams.token ? queryParams.token : queryParams.accessToken;
    return token;
  }
}

export function getMachineCode(){
  // if(process.env.NODE_ENV === "development") return "760CF0A3677613FAA5A76371C71B57DC";
  let queryParams = urlQueryParams();
  if(!queryParams) return "";
  if(queryParams.AES) {
    let decode = decodeURIComponent(queryParams.AES);
    let str = decryptData(decode);
    let query = JSON.parse(str);
    return query.machineCode;
  }else {
    return queryParams.machineCode;
  }
}

export function getEquipmentType(){
  let queryParams = urlQueryParams();
  if(!queryParams) return "";
  if(queryParams.AES) {
    let decode = decodeURIComponent(queryParams.AES);
    let str = decryptData(decode);
    let query = JSON.parse(str);
    return +query.equipmentType || 1;
  }else {
    return  +queryParams.equipmentType ? +queryParams.equipmentType : 1;
  }
}

export async function getVersionCode(){
  try {
    if(process.env.NODE_ENV === "development") return Promise.resolve("ios:9.2.5");
    await plusReady();
    let wgtInfo = await getProperty();
    return Promise.resolve(`${window.plus.os.name.toLowerCase()}:${wgtInfo.version}`);
  } catch (error) {
    console.log("getVersionCode error",error);
    return Promise.resolve("");
  }
}

function plusReady() {
  return new Promise(resolve => {
    window.plus ? resolve() : document.addEventListener('plusready', resolve);
  })
};


function getProperty(){
  return new Promise(resolve => {
    window.plus.runtime.getProperty( window.plus.runtime.appid, resolve );
  })
}

// AES加密函数
export function encryptData(data) {
	// return CryptoJS.AES.encrypt(data, secretKey).toString();
  let encJson = CryptoJS.AES.encrypt(data, secretKey).toString();
  let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
  return encData;
}

// AES解密函数
export function decryptData(ciphertext) {
  // const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
  // return bytes.toString(CryptoJS.enc.Utf8);
	//将数据先base64还原，再转为utf8数据
    let decData = CryptoJS.enc.Base64.parse(ciphertext).toString(CryptoJS.enc.Utf8);
    //解密数据
    let decJson = CryptoJS.AES.decrypt(decData, secretKey).toString(CryptoJS.enc.Utf8);
  return decJson;
}